export const GITLAB_RENDER_REPOS = 'GITLAB_RENDER_REPOS';

export const getGitlabRenderData = (data) => {
    return {
        type: GITLAB_RENDER_REPOS,
        gitlabRenderData: data
    }
};